import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { ControlResultLinkType } from "api/generated/model";
import { useGetUsersUserIdPendingControlResultsSuspense } from "api/generated/users/users";

export function usePendingControlResultsForUserQuery(
    userId: number,
    linkType: Exclude<ControlResultLinkType, "both">
) {
    return useGetUsersUserIdPendingControlResultsSuspense(
        userId,
        { link_type: linkType },
        {
            query: {
                select: (response) => response.data,
                refetchOnMount: true,
                refetchOnWindowFocus: true,
                staleTime: STALE_TIME_RESOURCES,
            },
        }
    );
}
